import { createSvgIcon } from '@material-ui/core';

export const LlmIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.7159 42L36.8881 34.0773H36.8331C36.8494 34.2829 36.8657 34.5613 36.882 34.9124C36.9024 35.2636 36.9207 35.6423 36.937 36.0486C36.9533 36.4549 36.9615 36.8461 36.9615 37.2223V42H34.8219V31H38.0373L39.9018 38.8098H39.9507L41.7785 31H45V42H42.781V37.1772C42.781 36.8311 42.7851 36.4599 42.7932 36.0636C42.8055 35.6623 42.8177 35.2861 42.8299 34.935C42.8462 34.5789 42.8605 34.298 42.8727 34.0923H42.8177L41.0144 42H38.7159Z"
      fill="currentColor"
    />
    <path
      d="M27.911 42V31H30.3256V39.5999H33.7672V42H27.911Z"
      fill="currentColor"
    />
    <path d="M21 42V31H23.4146V39.5999H26.8562V42H21Z" fill="currentColor" />
    <path
      d="M4.9519 4.99584C5.5614 4.35821 6.38805 4 7.25 4H20.25L30 14.2V24H26.75V15.9H18.625V7.4H7.25V34.6H18V38H7.25C6.38805 38 5.5614 37.6418 4.9519 37.0042C4.34241 36.3665 4 35.5017 4 34.6V7.4C4 6.49826 4.34241 5.63346 4.9519 4.99584Z"
      fill="currentColor"
    />
    <path d="M18 27.8V31.2H10.5V27.8H18Z" fill="currentColor" />
    <path d="M23.5 24H18V24.4H10.5V21H23.5V24Z" fill="currentColor" />
  </svg>,
  'LlmIcon',
);
